import React, { forwardRef } from 'react';
import { Select } from '../../../videos/components/FormInputs';
import { UI_LABEL_GROUPS } from '../../graphql/Queries';

const variablesSelector = ({ skip, limit, search }) => ({
  filter: { skip, limit, search },
  sort: { sortBy: 'DESC', sortOn: 'createdAt' }
});

const SelectUiLabelGroup = forwardRef(({ ...rest }, ref) => {
  return (
    <Select
      ref={ref}
      allowClear
      className="group-select"
      popupMatchSelectWidth={false}
      placeholder="Select Group"
      query={UI_LABEL_GROUPS}
      dataSelector={(response) =>
        response?.uiLabelGroupsAdmin?.uiLabelGroups?.map(({ name, id }) => ({
          label: name,
          value: id
        })) || []
      }
      keys={{
        data: 'uiLabelGroupsAdmin',
        records: 'uiLabelGroupsAdmin',
        count: 'count'
      }}
      variablesSelector={variablesSelector}
      {...rest}
    />
  );
});

SelectUiLabelGroup.displayName = 'SelectUiLabelGroup';

export default SelectUiLabelGroup;
